import React from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'

import FormWrapper from '../../../components/FormWrapper/FormWrapper'
import FormSection from '../../../components/FormSection/FormSection'
import FormInputsEn from './FormInputsEn'
import FormInputsSr from './FormInputsSr'
import FormInputs from './FormInputs'

const CertificateDocsForm = ({ initialValues, onSubmit, onDelete, language, isEditForm = false }) => {
    const payloadSchema = yup.object().shape({
        title: yup.string().required(),
        titleEn: yup.string(),
        image: yup.string().nullable(),
        document: yup.string().nullable(),
    })

    const _certificateDocsForm = (props) => {
        return (
            <FormSection
                {...props}
                FormInputsEn={FormInputsEn}
                FormInputsSr={FormInputsSr}
                FormInputs={FormInputs}
                isEditForm={isEditForm}
                onDelete={onDelete}
            />
        )
    }

    return (
        <FormWrapper>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={payloadSchema}
                onSubmit={onSubmit}
            >
                {_certificateDocsForm}
            </Formik>
        </FormWrapper>
    )
}

export default CertificateDocsForm
